/**
 * 底部信息（品牌简介 / 交易入口 / 帮助中心 / 关于 / 联系方式）
 */
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <div className="footer-logo">
              <span className="logo-mark">牛</span>
              <span>云牛集 · 牛只交易平台</span>
            </div>
            <p>
              山东牛产业智慧平台旗下公开交易门户。牛只现货交易、英式竞价拍卖、
              牛经纪撮合与实时行情一站式服务，区块链存证保障每一笔交易可信履约。
            </p>
          </div>

          <div className="footer-col">
            <h4>交易入口</h4>
            <Link to="/market">牛只市场</Link>
            <Link to="/auctions">竞价大厅</Link>
            <Link to="/listing/new">发布挂牌</Link>
            <Link to="/broker/orders">经纪撮合</Link>
          </div>

          <div className="footer-col">
            <h4>帮助中心</h4>
            <Link to="/market">交易规则</Link>
            <Link to="/market">交割流程</Link>
            <Link to="/quotes">资金监管说明</Link>
            <Link to="/market">常见问题</Link>
          </div>

          <div className="footer-col">
            <h4>关于平台</h4>
            <a href="https://www.yunniuji.com" target="_blank" rel="noreferrer">品牌官网</a>
            <a href="https://transport.yunniuji.com" target="_blank" rel="noreferrer">在途监管平台</a>
            <a href="https://www.yunniuji.com/about" target="_blank" rel="noreferrer">关于我们</a>
            <span>隐私政策</span>
            <span>用户协议</span>
            <span>区块链存证说明</span>
          </div>

          <div className="footer-col footer-contact">
            <h4>联系方式</h4>
            <div className="contact-item">📞 客服电话：400-800-8888</div>
            <div className="contact-item">✉️ 邮箱：service@yunniuji.com</div>
            <div className="contact-item">📍 地址：山东省济南市历城区智慧农业产业园</div>
          </div>
        </div>

        <div className="footer-bottom">
          <span>© 2026 武汉高灏科技有限责任公司 · 鄂ICP备15009094号-15</span>
          <span>让每一头牛都有可信档案，让每一笔交易都有可信履约</span>
        </div>
      </div>
    </footer>
  );
}
